import {
    SxProps,
    Backdrop,
    IconButton,
    Modal,
    Theme,
    Typography,
    useTheme,
} from '../../base';
import CloseIcon from '@mui/icons-material/Close';
import { ReactNode } from 'react';
import { ModalWrapper } from './PargodaModal.styles';

interface IPargodaModapProps {
    modalTitle?: string;
    isModalOpen: boolean;
    setIsModalOpen: (isModalOpen: boolean) => void;
    children: ReactNode;
    sx?: SxProps<Theme>;
    isDisableCloseButton?: boolean;
}
const PargodaModal = (props: IPargodaModapProps) => {
    const {
        isModalOpen,
        modalTitle = '',
        children,
        setIsModalOpen,
        sx,
        isDisableCloseButton = false,
    } = props;
    const theme = useTheme();
    return (
        <Modal
            aria-labelledby={modalTitle}
            open={isModalOpen}
            onClose={() => {
                setIsModalOpen(false);
            }}
            closeAfterTransition
            slots={{ backdrop: Backdrop }}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <ModalWrapper sx={sx}>
                <Typography
                    variant="h6"
                    fontWeight="bold"
                    sx={{ color: theme.palette.grey[600] }}
                >
                    {modalTitle}
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => {
                        setIsModalOpen(false);
                    }}
                    sx={{
                        position: 'absolute',
                        insetInlineEnd: 0,
                        top: 0,
                    }}
                    disabled={isDisableCloseButton}
                >
                    <CloseIcon />
                </IconButton>
                {children}
            </ModalWrapper>
        </Modal>
    );
};

export default PargodaModal;
